import ErrorIcon from '@mui/icons-material/Error';
import { Grid, Tab, Tabs } from '@mui/material';
import type { FormikProps } from 'formik';
import { useState } from 'react';
import AlmacenesTab from './AlmacenesTab';
import type { ArticuloFormValues } from './articulo.schema';
import EquivalenciasTab from './EquivalenciasTab';
import GrupoAgrupacionTab from './GrupoAgrupacionTab';

type ArticuloTabsProps = {
  formik: FormikProps<ArticuloFormValues>;
  inactivo: boolean;
  loading: boolean;
};

const ArticuloTabs = ({ formik, inactivo, loading }: ArticuloTabsProps) => {
  const [currentTab, setCurrentTab] = useState(0);
  const agrupacionesError =
    formik.touched.agrupaciones && Boolean(formik.errors.agrupaciones) ? (
      <ErrorIcon color="error" />
    ) : (
      <></>
    );
  const equivalenciasError =
    formik.touched.equivalencias && Boolean(formik.errors.equivalencias) ? (
      <ErrorIcon color="error" />
    ) : (
      <></>
    );
  const almacenesError =
    formik.touched.inventario && Boolean(formik.errors.inventario) ? (
      <ErrorIcon color="error" />
    ) : (
      <></>
    );

  return (
    <>
      <Grid>
        <Tabs value={currentTab} onChange={(_, v) => setCurrentTab(v)}>
          <Tab icon={agrupacionesError} iconPosition="end" label="Agrupaciones" />
          <Tab icon={equivalenciasError} iconPosition="end" label="Equivalencias" />
          <Tab icon={almacenesError} iconPosition="end" label="Almacenes" />
        </Tabs>
      </Grid>
      <Grid>
        <GrupoAgrupacionTab
          formik={formik}
          value={currentTab}
          inactivo={inactivo}
          loading={loading}
        />
        <EquivalenciasTab
          formik={formik}
          value={currentTab}
          inactivo={inactivo}
          loading={loading}
        />
        <AlmacenesTab
          formik={formik}
          value={currentTab}
          inactivo={inactivo}
          loading={loading}
        />
      </Grid>
    </>
  );
};

export default ArticuloTabs;
